import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { Booking } from "use-smart-locks-shared";
import { getBookingsByDeviceId } from "../../shared/api/nest-api";

export const useMyBookingsQuery = (
  deviceId: string | undefined,
): UseQueryResult<Booking[]> =>
  useQuery({
    queryKey: ["bookings", "my", deviceId],
    queryFn: () => {
      if (!deviceId) {
        return Promise.resolve([]);
      }
      return getBookingsByDeviceId(deviceId);
    },
    enabled: !!deviceId,
  });
